import { Translator } from 'Translator';
import classnames from 'classnames';
import PlusIcon from 'components/icons/PlusIcon';
import SearchIcon from 'components/icons/SearchIcon';
import useIsMobile from 'hooks/useIsMobile';
import React, { useState } from 'react';

import Tag from './Tag';

const CSS = require('./KeywordSearch.module.scss');

interface KeywordSearchProps {
  keywords: string[];
  onKeywordRemove: (keyword: string) => void;
  onKeywordAdd: (keyword: string) => void;
}

function KeywordSearch({
  keywords,
  onKeywordAdd,
  onKeywordRemove,
}: KeywordSearchProps) {
  const [value, setValue] = useState('');
  const isMobile = useIsMobile();

  const onChange = (e) => setValue(e.currentTarget.value);

  const onAdd = () => {
    onKeywordAdd(value);
    setValue('');
  };

  const onKeyUp = (e) => {
    if (e?.key === 'Enter') {
      e?.preventDefault();
      e?.stopPropagation();
      onAdd();
    }
  };

  return (
    <div className={CSS.KeywordSearch}>
      <span className={CSS.Title}>
        {Translator.translate(
          'UserEnvironment.Filters.keywords',
          {},
          true,
          'Keywords',
        )}
      </span>
      <div className={CSS.KeywordSearchInput}>
        <div className={CSS.SearchIconContainer}>
          <SearchIcon width={23} height={23} className={CSS.SearchIcon} />
        </div>
        <input
          autoFocus={!isMobile}
          className={CSS.KeywordInput}
          placeholder={Translator.translate(
            'UserEnvironment.Filters.keywordsPlaceholder',
            {},
            true,
            'For example: museum',
          )}
          name="keywords"
          onChange={onChange}
          onKeyUp={onKeyUp}
          type="text"
          value={value}
        />
        <button
          className={classnames(CSS.KeywordAddButton, {
            [CSS.KeywordAddButtonNoShow]: !value,
          })}
          onClick={onAdd}
        >
          <PlusIcon className={CSS.KeywordPlusIcon} width={18} height={18} />
        </button>
      </div>
      {keywords.length > 0 && (
        <div className={CSS.Keywords}>
          {keywords.map((keyword) => (
            <Tag key={keyword} name={keyword} onRemove={onKeywordRemove} />
          ))}
        </div>
      )}
    </div>
  );
}
export default KeywordSearch;
